import styled from "styled-components";
import {StyledGlobalMainContainer} from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  margin-top: 112px;
  @media (max-width: 768px) {
    padding: 0 22px 22px;
    margin-top: 99px;
  }
  @media (max-width: 425px) {
    padding: 0 22px 22px;
    margin-top: 76px;
  }
`;

export const StyledInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    &>div{
      max-width: 50%;
      justify-self: center;
      text-align: center;
    }
  };
`